var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/EcmasonDeserializeError.ts
var EcmasonSerializeError = class extends Error {
  constructor(tag) {
    super(`value of tag "${tag}" cannot be deserialized`);
  }
};

// src/EcmasonSerializeError.ts
var EcmasonSerializeError2 = class extends Error {
  constructor(value) {
    super("Failed to serialize value");
    this.value = value;
  }
};

// src/index.ts
var trackedTags = {};
var TRANSFORMERS = {
  literal: [],
  primitive: [],
  object: [],
  final: []
};
function addTransformer(type, transformer) {
  if (transformer.tag in trackedTags) {
    throw new Error(`Conflicting tag on '${transformer.tag}'`);
  }
  TRANSFORMERS[type].push(transformer);
}
function deserialize(value, context = {}) {
  for (let k = 0; k < TRANSFORMERS.literal.length; k += 1) {
    const transformer = TRANSFORMERS.literal[k];
    if (value.tag === transformer.tag) {
      return transformer.deserialize(value.value, context);
    }
  }
  for (let k = 0; k < TRANSFORMERS.primitive.length; k += 1) {
    const transformer = TRANSFORMERS.primitive[k];
    if (value.tag === transformer.tag) {
      return transformer.deserialize(value.value, context);
    }
  }
  for (let k = 0; k < TRANSFORMERS.object.length; k += 1) {
    const transformer = TRANSFORMERS.object[k];
    if (value.tag === transformer.tag) {
      return transformer.deserialize(value.value, context);
    }
  }
  for (let k = 0; k < TRANSFORMERS.final.length; k += 1) {
    const transformer = TRANSFORMERS.final[k];
    if (value.tag === transformer.tag) {
      return transformer.deserialize(value.value, context);
    }
  }
  throw new EcmasonSerializeError(value.tag);
}
function serialize(value, context = {}) {
  for (let i = 0; i < TRANSFORMERS.literal.length; i += 1) {
    const transformer = TRANSFORMERS.literal[i];
    if (transformer.check(value)) {
      return {
        tag: transformer.tag,
        value: transformer.serialize(value, context)
      };
    }
  }
  for (let i = 0; i < TRANSFORMERS.primitive.length; i += 1) {
    const transformer = TRANSFORMERS.primitive[i];
    if (transformer.check(value)) {
      return {
        tag: transformer.tag,
        value: transformer.serialize(value, context)
      };
    }
  }
  for (let i = 0; i < TRANSFORMERS.object.length; i += 1) {
    const transformer = TRANSFORMERS.object[i];
    if (transformer.check(value)) {
      return {
        tag: transformer.tag,
        value: transformer.serialize(value, context)
      };
    }
  }
  for (let i = 0; i < TRANSFORMERS.final.length; i += 1) {
    const transformer = TRANSFORMERS.final[i];
    if (transformer.check(value)) {
      return {
        tag: transformer.tag,
        value: transformer.serialize(value, context)
      };
    }
  }
  throw new EcmasonSerializeError2(value);
}
function stringify(value) {
  return JSON.stringify(serialize(value));
}
function parse(value) {
  return deserialize(JSON.parse(value));
}
addTransformer("literal", {
  tag: "NAN",
  check: (value) => Number.isNaN(value),
  serialize: () => null,
  deserialize: () => NaN
});
addTransformer("literal", {
  tag: "INF",
  check: (value) => value === Number.POSITIVE_INFINITY,
  serialize: () => null,
  deserialize: () => Number.POSITIVE_INFINITY
});
addTransformer("literal", {
  tag: "-INF",
  check: (value) => value === Number.NEGATIVE_INFINITY,
  serialize: () => null,
  deserialize: () => Number.NEGATIVE_INFINITY
});
addTransformer("literal", {
  tag: "-0",
  check: (value) => Object.is(value, -0),
  serialize: () => 0,
  deserialize: () => -0
});
addTransformer("primitive", {
  tag: "BIGINT",
  check: (value) => typeof value === "bigint",
  serialize: (value) => value.toString(),
  deserialize: (value) => BigInt(value)
});
addTransformer("primitive", {
  tag: "PRIMITIVE",
  check: (value) => typeof value === "number" || typeof value === "string" || typeof value === "boolean" || value === null,
  serialize: (value) => value,
  deserialize: (value) => value
});
addTransformer("primitive", {
  tag: "UNDEFINED",
  check: (value) => typeof value === "undefined",
  serialize: () => null,
  deserialize: () => void 0
});
function withRecursionTracker(transformer) {
  return {
    tag: `RECURSIVE(${transformer.tag})`,
    check: transformer.check,
    serialize: (value, context) => {
      var _a, _b;
      const currentTracker = (_a = context.recursiveTracker) != null ? _a : new WeakMap();
      const currentCount = (_b = context.recursiveCount) != null ? _b : 0;
      context.recursiveTracker = currentTracker;
      const tracked = currentTracker.get(value);
      if (tracked != null) {
        context.recursiveCount = currentCount;
        return tracked;
      }
      const newId = currentCount + 1;
      currentTracker.set(value, newId);
      context.recursiveCount = newId;
      return {
        id: newId,
        value: transformer.serialize(value, context)
      };
    },
    deserialize: (value, context) => {
      var _a;
      const currentRegenerator = (_a = context.recursiveRegenerator) != null ? _a : [];
      context.recursiveRegenerator = currentRegenerator;
      if (typeof value === "number") {
        return currentRegenerator[value];
      }
      const deserialized = transformer.deserialize(value.value, __spreadProps(__spreadValues({}, context), {
        setRef: (ref) => {
          currentRegenerator[value.id] = ref;
        }
      }));
      currentRegenerator[value.id] = deserialized;
      return deserialized;
    }
  };
}
addTransformer("object", {
  tag: "REGEXP",
  check: (value) => value instanceof RegExp,
  serialize: (value) => [value.source, value.flags],
  deserialize: ([source, flags]) => new RegExp(source, flags)
});
addTransformer("object", {
  tag: "DATE",
  check: (value) => value instanceof Date,
  serialize: (value) => value.toISOString(),
  deserialize: (value) => new Date(value)
});
addTransformer("object", withRecursionTracker({
  tag: "MAP",
  check: (value) => value instanceof Map,
  serialize: (value, context) => Array.from(value.entries()).map(([key, val]) => serialize([key, val], context)),
  deserialize: (value, context) => {
    var _a;
    const map = new Map();
    (_a = context.setRef) == null ? void 0 : _a.call(context, map);
    value.forEach((source) => {
      const [key, val] = deserialize(source, context);
      map.set(key, val);
    });
    return map;
  }
}));
addTransformer("object", withRecursionTracker({
  tag: "SET",
  check: (value) => value instanceof Set,
  serialize: (value, context) => Array.from(value).map((val) => serialize(val, context)),
  deserialize: (value, context) => {
    var _a;
    const set = new Set();
    (_a = context.setRef) == null ? void 0 : _a.call(context, set);
    value.forEach((val) => {
      set.add(deserialize(val, context));
    });
    return set;
  }
}));
addTransformer("object", withRecursionTracker({
  tag: "ARRAY",
  check: (value) => value instanceof Array,
  serialize: (value, context) => value.map((current) => serialize(current, context)),
  deserialize: (value, context) => {
    var _a;
    const array = [];
    (_a = context.setRef) == null ? void 0 : _a.call(context, array);
    value.forEach((current, key) => {
      array[key] = deserialize(current, context);
    });
    return array;
  }
}));
addTransformer("final", withRecursionTracker({
  tag: "OBJECT",
  check: (value) => typeof value === "object",
  serialize: (value, context) => Object.fromEntries(Object.entries(value).map(([key, val]) => [key, serialize(val, context)])),
  deserialize: (value, context) => {
    var _a;
    const obj = {};
    (_a = context.setRef) == null ? void 0 : _a.call(context, obj);
    Object.entries(value).forEach(([key, val]) => {
      obj[key] = deserialize(val, context);
    });
    return obj;
  }
}));
export {
  addTransformer,
  deserialize,
  parse,
  serialize,
  stringify,
  withRecursionTracker
};
/**
 * @license
 * MIT License
 *
 * Copyright (c) 2021 Alexis Munsayac
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 *
 * @author Alexis Munsayac <alexis.munsayac@gmail.com>
 * @copyright Alexis Munsayac 2021
 */
//# sourceMappingURL=index.js.map
